import ModalProvider from './ModalProvider';
import { useModal } from './hooks';
import { modalType } from './type';

export default ModalProvider;
export { useModal, modalType };
